import { exhaustiveCheck } from '@famly/stat_ts-utils_exhaustive-check';
const toSeverity = (statusType) => {
    switch (statusType) {
        case 'Success':
            return 'success';
        case 'Error':
            return 'error';
        case 'Info':
            return 'neutral';
        default:
            exhaustiveCheck(statusType);
            return 'neutral';
    }
};
/**
 * Adapts a dispatched global message into the shape the toast renderer takes.
 *
 * The `data-e2e-*` attributes are the contract Cypress selects toasts by, and `e2eId` lets a caller
 * name its own message so a spec can wait for that one rather than any toast.
 */
export const toToastEvent = (id, message) => ({
    id,
    message: message.message,
    severity: toSeverity(message.statusType),
    sticky: message.sticky,
    occurences: 1,
    duration: message.duration,
    'data-e2e-statustype': message.statusType,
    ...(message.e2eId ? { 'data-e2e-id': message.e2eId } : {}),
});
